export const getStyles = (_, { palette = {} } = {}) => {
  const pagerIcon = {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: 4,
    marginTop: 8,
  };

  const pageNavigationButton = {
    background: 'transparent',
  };

  const pageNumber = {
    fontSize: 12,
    lineHeight: '32px',
    color: palette.neutralPrimary,
  };

  return {
    pagerIcon,
    pageNavigationButton,
    pageNumber,
  };
};
